import React, { useEffect } from "react";
import "./main.css";
import img from "../../Assets/img1.jpg";
import { HiOutlineLocationMarker } from "react-icons/hi";
import { HiOutlineClipboardCheck } from "react-icons/hi";
import img2 from "../../Assets/img2.jpg";
import img3 from "../../Assets/img3.jpg";
import img4 from "../../Assets/img4.jpg";
import img5 from "../../Assets/img5.jpg";
import img6 from "../../Assets/img6.jpg";
import img7 from "../../Assets/img7.jpg";
import img8 from "../../Assets/img8.jpg";
import img9 from "../../Assets/img9.jpg";
import Aos from "aos";
import "aos/dist/aos.css";

const Data = [
  {
    id: 1,
    imgSrc: img,
    destTitle: "Bora Bora",
    location: "New Zealand",
    grade: "CULTURAL RELAX",
    fees: "$700",
    description:
      "The epitome of romance, Bora Bora is one of the best travel destinations in the world. This place is known for its luxurious stays and adventurous activities.",
  },
  {
    id: 2,
    imgSrc: img2,
    destTitle: "Machu Pechu",
    location: "Peru",
    grade: "CULTURAL RELAX",
    fees: "$600",
    description:
      "Huayna pechu is a mountain in Peru, rising over Machu Pichu, the so called Lost city of Incas. This place is popoular among tourist as the sunrise from the Sun Gate is simply spectucular.",
  },
  {
    id: 3,
    imgSrc: img3,
    destTitle: "Great Barrier Reef",
    location: "Australia",
    grade: "CULTURAL RELAX",
    fees: "$700",
    description:
      "One of the most remarkable Australian natural gift is the Great Brrier Reef. The hallmark of this place is`lavish` and `beauty`. Always interesting to be in this place",
  },
  {
    id: 4,
    imgSrc: img4,
    destTitle: "Capadocia",
    location: "Turkey",
    grade: "CULTURAL RELAX",
    fees: "$800",
    description:
      "According to word tourism ranking, 45 Million peoples visit turkey each year, and from that about 2 Million come to visit Capadocia. This place is known for its luxurious stays and adventurous activities.",
  },
  {
    id: 5,
    imgSrc: img5,
    destTitle: "Guanajuato",
    location: "Maxico",
    grade: "CULTURAL RELAX",
    fees: "$1100",
    description:
      "A city in central Maxico, Guanajuato is known for its history of silver mining and colonial architecture. The houses in the city are very attractively painted with the most bright color available. Always welcome.",
  },
  {
    id: 6,
    imgSrc: img6,
    destTitle: "Cinque Terre",
    location: "Italy",
    grade: "CULTURAL RELAX",
    fees: "$840",
    description:
      "The vibrant hues of the houses are its benchmark and explain the beauty of this place. Also if you are a foodie, and love seafood, you will be exhilirated with the choice you are about to get here. Happy exploring great food!",
  },
  {
    id: 7,
    imgSrc: img7,
    destTitle: "Angkor Wat",
    location: "Combodia",
    grade: "CULTURAL RELAX",
    fees: "$1100",
    description:
      "A city in central Maxico, Guanajuato is known for its history of silver mining and colonial architecture. The houses in the city are very attractively painted with the most bright color available. Always welcome.",
  },
  {
    id: 8,
    imgSrc: img8,
    destTitle: "Taj Mahal",
    location: "India",
    grade: "CULTURAL RELAX",
    fees: "$790",
    description:
      "A city in central Maxico, Guanajuato is known for its history of silver mining and colonial architecture. The houses in the city are very attractively painted with the most bright color available. Always welcome.",
  },
  {
    id: 9,
    imgSrc: img9,
    destTitle: "Bali Island",
    location: "Indonasia",
    grade: "CULTURAL RELAX",
    fees: "$500",
    description:
      "A city in central Maxico, Guanajuato is known for its history of silver mining and colonial architecture. The houses in the city are very attractively painted with the most bright color available. Always welcome.",
  },
];
const Main = () => {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  return (
    <section className="main container section">
      <div className="secTitle">
        <h3 data-aos="fade-right" className="title">
          Most visited destinations
        </h3>
      </div>
      <div className="secContent ">
        {Data.map(
          ({ id, imgSrc, destTitle, location, grade, fees, description }) => {
            return (
              <div key={id} data-aos="fade-up" className="singleDestination">
                <div className="imageDiv">
                  <img src={imgSrc} alt={destTitle} />
                </div>
                <div className="cardInfo">
                  <h4 className="destTitle">{destTitle}</h4>
                  <span className="continent flex">
                    <HiOutlineLocationMarker className="icon" />
                  </span>
                  <span className="name">{location}</span>
                  <div className="fees flex">
                    <div className="grade">
                      <span>
                        {grade}
                        <small>+1</small>
                      </span>
                    </div>
                    <div className="price">
                      <h5>{fees}</h5>
                    </div>
                  </div>
                  <div className="desc">
                    <p>{description}</p>
                  </div>
                  <button className="btn flex">
                    DETAILS
                    <HiOutlineClipboardCheck className="icon" />
                  </button>
                </div>
              </div>
            );
          }
        )}
      </div>
    </section>
  );
};

export default Main;
